import { render, staticRenderFns } from "./VisitCard.vue?vue&type=template&id=b1436e60&scoped=true&"
import script from "./VisitCard.ts?vue&type=script&lang=ts&"
export * from "./VisitCard.ts?vue&type=script&lang=ts&"
import style0 from "./VisitCard.scss?vue&type=style&index=0&id=b1436e60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1436e60",
  null
  
)

export default component.exports